import { render, staticRenderFns } from "./UserRoleSet.vue?vue&type=template&id=1a28b0c2&scoped=true&"
import script from "./UserRoleSet.vue?vue&type=script&lang=js&"
export * from "./UserRoleSet.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleSet.vue?vue&type=style&index=0&id=1a28b0c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28b0c2",
  null
  
)

export default component.exports